document.addEventListener('DOMContentLoaded', () => {
	const
	heroCarouselSection = document.getElementById('hero-carousel');
	
	
	if (heroCarouselSection != null) {
		const 
		heroCarouselWrapper = heroCarouselSection.querySelector('.block-content');
		heroCarouselWrapper.classList.add('swiper-container');
		heroCarouselWrapper.querySelector('.field-images').classList.add('swiper-wrapper');
		heroCarouselWrapper.querySelectorAll('.field-image').forEach(e => e.classList.add('swiper-slide'));
	
		const
		heroCarousel = new Swiper(heroCarouselWrapper, {
			autoHeight: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			}
		});
	}
});
